// ----------------------------------------------------------------------

export default function Breadcrumbs({ theme }) {
  return {
    MuiBreadcrumbs: {
      styleOverrides: {
        separator: {
          marginLeft: 16,
          marginRight: 16
        }
      }
    }
  };
}
